module.exports = __webpack_public_path__ + "static/media/person.a3d9c3b5.png";